import { useTranslation } from "react-i18next";
import { Heading, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import React from "react";

function StepFive() {
  const { t } = useTranslation("translation", {
    keyPrefix: "issbPlan.planDetails.modals.stepFive"
  });

  return (
    <>
      <Heading size="lg" marginBottom={5}>
        {t("title")}
      </Heading>
      <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
        {t("context")}
      </Text>
      <Text fontSize="lg" marginBottom={8}>
        {t("contextContent")}
      </Text>
      <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
        {t("actions")}
      </Text>
      <UnorderedList marginLeft={8} marginBottom={8}>
        <ListItem>
          <Text fontSize="lg">
            {t("actionsContent.actionOne")}
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize="lg">
            {t("actionsContent.actionTwo")}
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize="lg">
            {t("actionsContent.actionThree")}
          </Text>
        </ListItem>
      </UnorderedList>
      <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
        {t("stakeholders")}
      </Text>
      <UnorderedList marginLeft={8} marginBottom={4}>
        <ListItem>
          <Text fontSize="lg">
            {t("stakeholdersContent.stakeholderOne")}
          </Text>
        </ListItem>
        <ListItem>
          <Text fontSize="lg">
            {t("stakeholdersContent.stakeholderTwo")}
          </Text>
        </ListItem>
      </UnorderedList>
    </>
  );
}

export default StepFive;